import React from 'react';
import { useSelector } from 'react-redux';
import { CONTACTS } from '@department-of-veterans-affairs/component-library/contacts';
import { genderLabels } from 'platform/static-data/labels';
import { formatDateLong } from '../../shared/utils/dates';

// Read-only veteran identity, mirroring the live 526 flow. Name, DOB, and gender
// come from the authenticated profile. Nothing here is editable — identity is
// updated through VBA.
export default function VeteranInformationCard() {
  const profile = useSelector(state => state.user?.profile) || {};
  const { dob, gender } = profile;
  const { first, middle, last, suffix } = profile.userFullName || {};
  const fullName = [first, middle, last].filter(Boolean).join(' ');

  return (
    <div>
      <p className="vads-u-margin-top--0">
        This is the personal information we have on file for you.
      </p>
      <p className="va-address-block">
        <strong>
          {fullName}
          {suffix ? `, ${suffix}` : ''}
        </strong>
        <br />
        Date of birth: {dob ? formatDateLong(dob) : ''}
        <br />
        Gender: {genderLabels[gender]}
      </p>
      <p>
        <strong>Note:</strong> If you need to update your personal information,
        please call Veterans Benefits Assistance at{' '}
        <va-telephone contact={CONTACTS.VA_BENEFITS} />, Monday through Friday,
        8:00 a.m. to 9:00 p.m. ET.
      </p>
    </div>
  );
}
